import api from "./api";

class LinksManager {

    links(config?: any) {
        return api.get(`/links`, config)
    }

    linksCreate(data: any) {
        return api.post(`/links`, data)
    }

    polizzaLinkCreate(data:any){
        return api.post(`/links/polizze/`, data)
    }
    visureLinkCreate(data:any){
        return api.post(`/links/visure/`, data)
    }
    albiLinkCreate(data:any){
        return api.post(`/links/albi/`, data)
    }

}

const linksManager = new LinksManager()

export default linksManager
